import { Field, useFormikContext } from 'formik';
import React, { FC, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import { IAppState } from '../../store/types';
import { validateItemName } from '../../utilities/Validation';
import EntityHierarchy from '../entityHierarchy/entityHierarchy';
import Label from '../label/label';
import useFocusOnRouteChange from '../../hooks/useFocusOnRouteChange';

const SimpleItemCard: FC = () => {
    const { errors, values } = useFormikContext<any>();
    const { translate } = useLocale();
    const site = useSelector((state: IAppState) => state.site.site.label)

    const inputRef = useRef<HTMLInputElement>(null);
    useFocusOnRouteChange(inputRef);

    return <div className="w-full p-2 inline-flex justify-start items-center bg-white">
        {values.id ?
            (<div className="ml-8 mr-5 card-details">
                <EntityHierarchy title={values.name} tree={{ label: values.site, node: { label: values.name } }} />
            </div>) : ""}
        <div className="flex flex-col py-4 px-8">
            <div className="flex flex-row justify-between" id="nameLabel">
                <Label
                    htmlFor="name"
                    className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
            </div>
            <Field
                type="text"
                name="name"
                innerRef={inputRef}
                className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input" id="nameInput"
                validate={(value) => validateItemName(value, translate)} />
        </div>
        <div className="flex flex-col py-4 px-8">
            <div className="flex flex-row justify-between" id="siteLabel">
                <Label
                    htmlFor="siteId"
                    className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.site)}:</Label>
                {errors.siteId ? <span className='text-red-600 text-xs'>{errors.siteId}</span> : null}
            </div>
            {values.id
                ? <Field
                    value={values.site}
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                : <Field
                    value={site}
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />}
        </div>
    </div>
};

export default SimpleItemCard;
